import * as Yup from 'yup'

export interface ICreateProvidence {
  description?: string
  character?: 'imposing' | 'informative'
  observation?: string
  start_date?: string
  conclusion_date?: string
  limit_date?: string
  code?: string
  status?: 'not_started' | 'in_progress' | 'expired' | 'canceled' | 'done' | ''
  id?: number
  uuid?: string
  license_id?: number
  external_email?: string []
  alert_days?: number[]
  providence_number?: string
  responsible_id?: number[]
  responsible?: string
  responsibles?: [
    {
      id: number
    }
  ]
  situation?: string

  license?: {
    license_number?: string
    uuid?: string
  }
  providenceManagementAlertDay?: [
    {
      id?: number
      alert_day?: number
    }
  ]

  file?: string
  project_id?: number
  path?: File []
  externalEmails?: any []

   
}

const createProvidenceSchemas = [
  Yup.object({
    
  }),

  Yup.object({
    description: Yup.string().required('Campo obrigatório'),
    responsible_id: Yup.array().required('Campo obrigatório'),
    providence_number: Yup.string().required('Campo obrigatório'), 
  }),
  Yup.object({
    start_date: Yup.string().required('Campo obrigatório'),
    limit_date: Yup.string().required('Campo obrigatório'),
    status: Yup.string().required('Campo obrigatório'),
    alert_days: Yup.array().min(1, 'Campo obrigatório'),
  }) 
]

const inits: ICreateProvidence = {
 
}

export {createProvidenceSchemas, inits}
